module.exports = __webpack_public_path__ + "img/FOTO-DANI.12d81feb.png";